import React from 'react';
import './TeamRanking.css'; // Make sure to create this CSS file

function TeamRanking() {
  return (
    <div className="team-ranking-container">
      <div className="under-construction-banner">
        🚧 This page is under construction. Please check back soon! 🚧
      </div>
      <h1 className="team-ranking-heading">Team Ranking Page</h1>
    </div>
  );
}

export default TeamRanking;
